const enum ResponseTypes {
    None = 1,
    Data = 2,
    Payload = 3,
    Resource = 4
};
export default ResponseTypes;